<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    <i class="fas fa-history ch-title-icon" aria-hidden="true"></i>{{ "Contact History" }}
  </h4>
  <button
    type="button"
    class="close"
    style="color: white"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body ch">
  <!-- Appointment overview -->
  <section class="ch-card ch-overview" aria-label="Appointment overview">
    <div class="ch-stat">
      <span class="ch-label"><i class="fas fa-calendar-day" aria-hidden="true"></i>Appointment Date</span>
      <span class="ch-value">{{reminderData.appt_date ? reminderData.appt_date : "Not Specified"}}</span>
    </div>
    <div class="ch-stat">
      <span class="ch-label"><i class="fas fa-clock" aria-hidden="true"></i>Appointment Time</span>
      <span class="ch-value">{{reminderData.appt_time ? reminderData.appt_time : "Not Specified"}}</span>
    </div>
    <div class="ch-stat">
      <span class="ch-label"><i class="fas fa-check-circle" aria-hidden="true"></i>Confirmed</span>
      <span class="ch-value">
        <span class="ch-pill" [ngClass]="reminderData.is_confirmed ? 'ch-pill--success' : 'ch-pill--muted'">{{reminderData.is_confirmed ? "Yes" : "No"}}</span>
      </span>
    </div>
    <div class="ch-stat">
      <span class="ch-label"><i class="fas fa-mobile-alt" aria-hidden="true"></i>Cell Number</span>
      <span class="ch-value">{{reminderData.cellNumber ? reminderData.cellNumber : "Not Specified"}}</span>
    </div>
    <div class="ch-stat" *ngIf="reminderData.secondaryCellNumber">
      <span class="ch-label"><i class="fas fa-mobile-alt" aria-hidden="true"></i>Secondary Cell</span>
      <span class="ch-value">{{reminderData.secondaryCellNumber}}</span>
    </div>
  </section>

  <!-- Reminder delivery: when each reminder went out and to which number(s) -->
  <h5 class="ch-section-title"><i class="fas fa-paper-plane" aria-hidden="true"></i>Reminder Delivery</h5>
  <div class="row">
    <div class="col-md-6 mb-3">
      <section class="ch-card ch-channel ch-channel--sms h-100">
        <header class="ch-channel__head">
          <span class="ch-icon" aria-hidden="true"><i class="fas fa-comment-dots"></i></span>
          <h6 class="ch-channel__title">SMS Reminder</h6>
        </header>
        <dl class="ch-meta">
          <div class="ch-meta__row">
            <dt>SMS Sent At</dt>
            <dd>{{reminderData.dateTimeSmsSent ? reminderData.dateTimeSmsSent : 'Not Specified'}}</dd>
          </div>
          <div class="ch-meta__row">
            <dt>Sent To</dt>
            <dd>
              <ng-container
                *ngTemplateOutlet="numberChips; context: { numbers: smsSentNumbers, emptyText: reminderData.dateTimeSmsSent ? 'Not recorded' : 'Not Specified' }"
              ></ng-container>
            </dd>
          </div>
        </dl>
      </section>
    </div>
    <div class="col-md-6 mb-3">
      <section class="ch-card ch-channel ch-channel--voice h-100">
        <header class="ch-channel__head">
          <span class="ch-icon" aria-hidden="true"><i class="fas fa-phone"></i></span>
          <h6 class="ch-channel__title">Call Reminder</h6>
        </header>
        <dl class="ch-meta">
          <div class="ch-meta__row">
            <dt>Call Sent At</dt>
            <dd>{{reminderData.dateTimeCallSent ? reminderData.dateTimeCallSent : 'Not Specified'}}</dd>
          </div>
          <div class="ch-meta__row">
            <dt>Called Number</dt>
            <dd>
              <ng-container
                *ngTemplateOutlet="numberChips; context: { numbers: voiceCalledNumbers, emptyText: reminderData.dateTimeCallSent ? 'Not recorded' : 'Not Specified' }"
              ></ng-container>
            </dd>
          </div>
        </dl>
      </section>
    </div>
  </div>

  <!-- Primary Phone Results -->
  <h5 class="ch-section-title">
    <i class="fas fa-mobile-alt" aria-hidden="true"></i>
    <ng-container *ngIf="reminderData.secondaryCellNumber; else generalResultsTitle">Primary Phone ({{reminderData.cellNumber}})</ng-container>
    <ng-template #generalResultsTitle>Delivery Results</ng-template>
  </h5>
  <ng-container
    *ngTemplateOutlet="phoneResults; context: { sms: reminderData.smsResult, calls: reminderData.callResults }"
  ></ng-container>

  <!-- Secondary Phone Results -->
  <ng-container *ngIf="reminderData.secondaryCellNumber">
    <h5 class="ch-section-title">
      <i class="fas fa-mobile-alt" aria-hidden="true"></i>Secondary Phone ({{reminderData.secondaryCellNumber}})
    </h5>
    <ng-container
      *ngTemplateOutlet="phoneResults; context: { sms: reminderData.secondarySmsResult, calls: reminderData.secondaryCallResults }"
    ></ng-container>
  </ng-container>
</div>

<!-- Number(s) a reminder went to, tagged Primary / Secondary / Other -->
<ng-template #numberChips let-numbers="numbers" let-emptyText="emptyText">
  <ul class="ch-numbers" *ngIf="numbers.length; else noNumbers">
    <li class="ch-number" *ngFor="let n of numbers">
      <i class="fas fa-mobile-alt ch-number__icon" aria-hidden="true"></i>
      <span class="ch-number__value">{{n.number}}</span>
      <span
        class="ch-tag"
        [ngClass]="'ch-tag--' + n.role"
        [attr.title]="n.role === 'other' ? 'No longer matches the current cell or secondary number' : null"
        >{{n.label}}</span
      >
    </li>
  </ul>
  <ng-template #noNumbers><span class="ch-muted">{{emptyText}}</span></ng-template>
</ng-template>

<!-- SMS + call results for one phone number -->
<ng-template #phoneResults let-sms="sms" let-calls="calls">
  <div class="row">
    <div class="col-md-6 mb-3">
      <section class="ch-card ch-results h-100">
        <h6 class="ch-results__title">
          <i class="fas fa-comment-dots" aria-hidden="true"></i>SMS Result(s)
          <span class="ch-count" *ngIf="sms.length > 0">{{sms.length}}</span>
        </h6>
        <div class="ch-empty" *ngIf="sms.length === 0">
          <i class="fas fa-inbox" aria-hidden="true"></i>{{'No Sms Initiated'}}
        </div>
        <div class="ch-table-wrap" *ngIf="sms.length > 0">
          <table class="table table-striped table-hover ch-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Status</th>
                <th scope="col">Date</th>
                <th scope="col">Content</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of sms; let i = index">
                <th scope="row">{{i + 1}}</th>
                <td><span class="ch-badge" [ngClass]="statusClass(record.status)">{{record.status | titlecase}}</span></td>
                <td *ngIf="record.date_sent">{{record.date_sent | date: 'MM/dd/yyyy hh:mm a' }}</td>
                <td *ngIf="!record.date_sent">Not Specified</td>
                <td class="ch-content">{{record.body}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
    <div class="col-md-6 mb-3">
      <section class="ch-card ch-results h-100">
        <h6 class="ch-results__title">
          <i class="fas fa-phone" aria-hidden="true"></i>Call Result(s)
          <span class="ch-count" *ngIf="calls.length > 0">{{calls.length}}</span>
        </h6>
        <div class="ch-empty" *ngIf="calls.length === 0">
          <i class="fas fa-inbox" aria-hidden="true"></i>{{'No Calls Initiated'}}
        </div>
        <div class="ch-table-wrap" *ngIf="calls.length > 0">
          <table class="table table-striped table-hover ch-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Status</th>
                <th scope="col">Date</th>
                <th scope="col">Duration (seconds)</th>
                <th scope="col">Answered By</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of calls; let i = index">
                <th scope="row">{{i + 1}}</th>
                <td *ngIf="record.status">
                  <span class="ch-badge" [ngClass]="statusClass(record.status)">{{record.status | titlecase}}</span>
                </td>
                <td *ngIf="!record.status">Not Specified</td>
                <td *ngIf="record.date_called">{{record.date_called | date: 'dd/MM/yyyy hh:mm a' }}</td>
                <td *ngIf="!record.date_called">Not Specified</td>
                <td>{{record.duration ? record.duration : "Not Specified"}}</td>
                <td>{{checkAnsweredBy(record.answered_by)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>
</ng-template>
